import React, { useEffect, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';
import BrutalistButton2 from '../shared/BrutalistButton2';
import './ListarSegmentacoes.css';
//import { TabContext } from '../SmartCampaignsDashboard';
import { listarCampanhas, deletarCampanha } from '../../../../services/api';

const ListarCampanhas = ({ onEditCampanha, onCriarCampanha }) => {
  //const { setTab } = useContext(TabContext);
  const [campanhas, setCampanhas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  useEffect(() => {
    async function fetchCampanhas() {
      setLoading(true);
      try {
        const data = await listarCampanhas();
        setCampanhas(data || []);
      } catch (err) {
        console.error('Erro ao listar campanhas:', err);
        setCampanhas([]);
      }
      setLoading(false);
    }
    fetchCampanhas();
  }, []);

  const handleExcluir = async (id) => {
    try {
      await deletarCampanha(id);
      setSnackbar({ open: true, message: 'Campanha excluída com sucesso!', severity: 'success' });
      setCampanhas((items) => items.filter((c) => c.id !== id));
    } catch (error) {
      console.error('Erro ao excluir campanha:', error);
      setSnackbar({ open: true, message: 'Erro ao excluir campanha.', severity: 'error' });
    }
  };

  return (
    <div className="segmentacoes-wrapper">
      <div className="segmentacoes-header" style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '2rem'
      }}>
        <h1 className="segmentacoes-title" style={{
          fontSize: '2rem',
          fontWeight: 'bold',
          borderBottom: '4px solid #000',
          display: 'inline-block',
          paddingBottom: '4px',
          transform: 'rotate(-1deg)',
          margin: 0
        }}>
          CAMPANHAS
        </h1>
        <BrutalistButton2 className="orange" onClick={onCriarCampanha}>
          CRIAR CAMPANHA
        </BrutalistButton2>
      </div>

      <div className="segmentacoes-lista">
        {loading && <div>Carregando...</div>}
        {!loading && campanhas.length === 0 && <div>Nenhuma campanha encontrada.</div>}
        {campanhas.map((c) => (
          <div key={c.id} className="segment-card">
            <div className="segment-info">
              <div className="segment-nome">{c.nome}</div>
              <div className="segment-clientes">{c.mensagem}</div>
            </div>
            <div className="segment-acoes">
              <button type="button" className="segment-edit" onClick={() => onEditCampanha(c.id)} aria-label="Editar campanha">✏️</button>
              <button type="button" className="segment-delete" onClick={() => handleExcluir(c.id)} aria-label="Excluir campanha">🗑️</button>
            </div>
          </div>
        ))}
      </div>      
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert severity={snackbar.severity} variant="filled">{snackbar.message}</Alert>
      </Snackbar>
    </div>
  );
};

export default ListarCampanhas;

